import confirmService from '@/lib/services/confirmService';

/**
 * Composable per ConfirmService - versione moderna per Composition API
 * Wrappa il ConfirmService esistente con API più moderna e type-safe
 */
export function useConfirmService() {
	/**
	 * Promise-based confirm dialog (più moderno del callback)
	 */
	const confirm = (
		message: string,
		title?: string,
		type: 'success' | 'warning' | 'error' | 'info' = 'warning',
	): Promise<boolean> => {
		return new Promise((resolve) => {
			const method =
				type === 'success'
					? 'openSuccessConfirm'
					: type === 'error'
						? 'openErrorConfirm'
						: type === 'info'
							? 'openInfoConfirm'
							: 'openWarningConfirm';
			confirmService[method](
				() => resolve(true), // onConfirm
				null, // param1
				null, // param2
				title, // title
				message, // message
				() => resolve(false), // onCancel
			);
		});
	};

	/**
	 * Wrapper semplificati per ogni tipo
	 */
	const confirmSuccess = (message: string, title = 'Continuare?') =>
		confirm(message, title, 'success');

	const confirmWarning = (message: string, title = 'Attenzione!') =>
		confirm(message, title, 'warning');

	const confirmError = (message: string, title = 'Errore!') => confirm(message, title, 'error');

	const confirmInfo = (message: string, title = 'Info') => confirm(message, title, 'info');

	/**
	 * Access diretto al service per retrocompatibilità
	 */
	const service = confirmService;

	return {
		// Promise-based API (moderno)
		confirm,
		confirmSuccess,
		confirmWarning,
		confirmError,
		confirmInfo,

		// Service originale (retrocompatibilità)
		service,
	};
}
